import React, { Component } from 'react';

import ToggleSwitch from '../common/form/ToggleSwitch';

function agruparPermissoes(lista) {
  const grupos = [];
  let atual = null;

  (lista || []).forEach((item, index) => {
    if (item.tipo === 'T') {
      atual = { tela: { ...item, index }, campos: [] };
      grupos.push(atual);
    } else if (item.tipo === 'C' && atual) {
      atual.campos.push({ ...item, index });
    }
  });

  return grupos;
}

function telaAtiva(item) {
  return parseInt(item.permissao, 10) === 0;
}

function campoAtivo(item) {
  return parseInt(item.permissao, 10) === 1;
}

function contarAtivos(permissoes) {
  const telas = (permissoes || []).filter(p => p.tipo === 'T' && telaAtiva(p)).length;
  const campos = (permissoes || []).filter(p => p.tipo === 'C' && campoAtivo(p)).length;
  return { telas, campos };
}

class PermissaoList extends Component {
  constructor(props) {
    super(props);

    this.state = {
      busca: '',
      expandidos: {},
    };

    this.handleBusca = this.handleBusca.bind(this);
    this.toggleExpandir = this.toggleExpandir.bind(this);
    this.expandirTodos = this.expandirTodos.bind(this);
    this.recolherTodos = this.recolherTodos.bind(this);
    this.atualizarPermissao = this.atualizarPermissao.bind(this);
    this.alternarTela = this.alternarTela.bind(this);
    this.alternarCampo = this.alternarCampo.bind(this);
  }

  get permissoes() {
    return this.props.permissoes || this.props['data-list'] || [];
  }

  emitirAlteracao(novasPermissoes) {
    if (this.props.onChange) {
      this.props.onChange(novasPermissoes);
    }
  }

  atualizarPermissao(index, valor) {
    const permissoes = [...this.permissoes];
    if (!permissoes[index]) return;

    permissoes[index] = {
      ...permissoes[index],
      permissao: valor,
    };

    this.emitirAlteracao(permissoes);
  }

  alternarTela(grupo) {
    const permissoes = [...this.permissoes];
    const ativo = telaAtiva(grupo.tela);
    const novoValor = ativo ? 2 : 0;

    permissoes[grupo.tela.index] = {
      ...permissoes[grupo.tela.index],
      permissao: novoValor,
    };

    grupo.campos.forEach(campo => {
      permissoes[campo.index] = {
        ...permissoes[campo.index],
        permissao: ativo ? 0 : 1,
      };
    });

    this.emitirAlteracao(permissoes);
  }

  alternarCampo(campo) {
    const ativo = campoAtivo(campo);
    this.atualizarPermissao(campo.index, ativo ? 0 : 1);
  }

  handleBusca(event) {
    this.setState({ busca: event.target.value || '' });
  }

  toggleExpandir(telaId) {
    this.setState(prev => ({
      expandidos: {
        ...prev.expandidos,
        [telaId]: !prev.expandidos[telaId],
      },
    }));
  }

  expandirTodos(grupos) {
    const expandidos = {};
    grupos.forEach(g => {
      expandidos[g.tela.t_id] = true;
    });
    this.setState({ expandidos });
  }

  recolherTodos(grupos) {
    const expandidos = {};
    (grupos || []).forEach(g => {
      expandidos[g.tela.t_id] = false;
    });
    this.setState({ expandidos });
  }

  grupoVisivel(grupo, termo) {
    if (!termo) return true;
    const texto = termo.toLowerCase();
    if ((grupo.tela.descricao || '').toLowerCase().includes(texto)) return true;
    return grupo.campos.some(c => (c.descricao || '').toLowerCase().includes(texto));
  }

  grupoExpandido(grupo, termo) {
    if (termo) return true;
    const { expandidos } = this.state;
    return !!expandidos[grupo.tela.t_id];
  }

  renderGrupo(grupo, termo) {
    const telaLigada = telaAtiva(grupo.tela);
    const camposAtivos = grupo.campos.filter(campoAtivo).length;
    const temFilhos = grupo.campos.length > 0;
    const expandido = temFilhos && this.grupoExpandido(grupo, termo);

    return (
      <div
        key={`tela-${grupo.tela.t_id}`}
        className={`permissao-premium-group${telaLigada ? ' permissao-premium-group--ativo' : ''}${
          !temFilhos ? ' permissao-premium-group--simples' : ''
        }`}
      >
        <div className="permissao-premium-group-header">
          {temFilhos ? (
            <button
              type="button"
              className="permissao-premium-group-toggle"
              onClick={() => this.toggleExpandir(grupo.tela.t_id)}
              aria-expanded={expandido}
            >
              <i className={`fa fa-chevron-${expandido ? 'down' : 'right'}`} />
            </button>
          ) : null}

          <div className="permissao-premium-group-info">
            <div className="permissao-premium-group-text">
              <strong>{grupo.tela.descricao}</strong>
              <span>
                {temFilhos
                  ? `${camposAtivos}/${grupo.campos.length} ações permitidas`
                  : 'Acesso à tela'}
              </span>
            </div>
          </div>

          <div className="permissao-premium-group-action">
            <span className={`permissao-premium-status ${telaLigada ? 'is-on' : 'is-off'}`}>
              {telaLigada ? 'Permitido' : 'Bloqueado'}
            </span>
            <ToggleSwitch
              isOn={telaLigada}
              onToggle={() => this.alternarTela(grupo)}
              size="small"
              onColor="#3c8dbc"
              offColor="#94a3b8"
            />
          </div>
        </div>

        {expandido && temFilhos && (
          <div className="permissao-premium-campos">
            {grupo.campos.map(campo => {
              const ativo = campoAtivo(campo);
              return (
                <div
                  key={`campo-${grupo.tela.t_id}-${campo.c_id}`}
                  className={`permissao-premium-campo-row${ativo ? ' permissao-premium-campo-row--ativo' : ''}`}
                >
                  <div className="permissao-premium-campo-label">
                    <i className="fa fa-long-arrow-alt-right" />
                    <span>{campo.descricao}</span>
                  </div>
                  <div className="permissao-premium-campo-action">
                    <span className={`permissao-premium-status ${ativo ? 'is-on' : 'is-off'}`}>
                      {ativo ? 'Sim' : 'Não'}
                    </span>
                    <ToggleSwitch
                      isOn={ativo}
                      onToggle={() => this.alternarCampo(campo)}
                      size="small"
                      onColor="#27ae60"
                      offColor="#cbd5e1"
                      disabled={!telaLigada}
                    />
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </div>
    );
  }

  render() {
    const permissoes = this.permissoes;
    const loading = this.props.loading;

    if (loading) {
      return (
        <div className="permissao-premium permissao-premium--loading">
          <i className="fa fa-spinner fa-spin" /> Carregando permissões...
        </div>
      );
    }

    if (!permissoes.length) {
      return (
        <div className="permissao-premium permissao-premium--empty">
          <i className="fa fa-lock" />
          <span>Nenhuma permissão disponível para este grupo.</span>
        </div>
      );
    }

    const termo = (this.state.busca || '').trim().toLowerCase();
    const grupos = agruparPermissoes(permissoes);
    const gruposVisiveis = grupos.filter(grupo => this.grupoVisivel(grupo, termo));
    const { telas, campos } = contarAtivos(permissoes);

    return (
      <div className="permissao-premium">
        <div className="permissao-premium-toolbar">
          <div className="permissao-premium-search">
            <i className="fa fa-search" />
            <input
              type="text"
              className="form-control"
              placeholder="Buscar tela ou ação..."
              value={this.state.busca}
              onChange={this.handleBusca}
            />
          </div>
          <div className="permissao-premium-toolbar-actions">
            <button type="button" className="btn btn-default btn-sm" onClick={() => this.expandirTodos(gruposVisiveis)}>
              Expandir tudo
            </button>
            <button type="button" className="btn btn-default btn-sm" onClick={() => this.recolherTodos(gruposVisiveis)}>
              Recolher tudo
            </button>
          </div>
          <div className="permissao-premium-stats">
            <span>
              <strong>{telas}</strong> telas
            </span>
            <span>
              <strong>{campos}</strong> ações
            </span>
          </div>
        </div>

        {gruposVisiveis.length === 0 ? (
          <div className="permissao-premium-empty-search">
            <i className="fa fa-search" />
            <span>Nenhuma permissão encontrada para &quot;{this.state.busca}&quot;.</span>
          </div>
        ) : (
          <div className="permissao-premium-groups">
            {gruposVisiveis.map(grupo => this.renderGrupo(grupo, termo))}
          </div>
        )}
      </div>
    );
  }
}

export default PermissaoList;
